import type { LookAtThatMemoryNote } from '../../lib/lookAtThatApi';

interface Props {
  notes: LookAtThatMemoryNote[];
  onDelete: (noteId: string) => void;
}

/**
 * "What the bot knows": navigation/behaviour facts accumulated by every
 * calibrate / explore / play task. Injected into future task preambles, so
 * the operator can prune wrong observations before they poison later runs.
 */
export function GameMemoryCard({ notes, onDelete }: Props) {
  return (
    <div className="card">
      <details open={notes.length > 0 && notes.length <= 6}>
        <summary style={{ cursor: 'pointer' }}>
          <strong>What the bot knows</strong>{' '}
          <span className="muted small">
            {notes.length ? `${notes.length} fact(s) — fed into every task` : '— nothing learned yet'}
          </span>
        </summary>
        {notes.length === 0 ? (
          <p className="muted small" style={{ margin: '8px 0 0' }}>
            After each calibrate / explore / play the bot notes new UI facts (menu locations, popups,
            paytable layout). Studio-wide facts (source: studio) are reused on every game from that
            studio. Prune anything wrong — they feed later tasks.
          </p>
        ) : (
          <ul className="small" style={{ margin: '8px 0 0', paddingLeft: 0, listStyle: 'none' }}>
            {notes.map((n) => (
              <li
                key={n.id}
                className="row"
                style={{ gap: 8, padding: '4px 0', borderBottom: '1px solid var(--border)' }}
              >
                <span className="badge small" title={new Date(n.ts).toLocaleString()}>
                  {n.source}
                  {n.testKey ? ` · ${n.testKey}` : ''}
                </span>
                <span style={{ flex: 1 }}>{n.text}</span>
                <button
                  type="button"
                  className="btn-ghost small"
                  title="Forget this (wrong observations poison future tasks)"
                  onClick={() => onDelete(n.id)}
                >
                  ×
                </button>
              </li>
            ))}
          </ul>
        )}
      </details>
    </div>
  );
}
